/**
 * Resolves the user's email address from Azure B2C identity claims. B2C tokens
 * carry the email under different keys depending on the policy/account source,
 * so we try the common shapes in order: a scalar `email`, the first entry of an
 * `emails` array, then `signInName`. Returns null when none resolve.
 * @param claims the identity claims object from OAuthService, or null
 * @returns the resolved email address, or null
 */
export function resolveEmailFromClaims(claims: Record<string, unknown> | null): string | null {
  if (!claims) {
    return null;
  }
  const email = claims['email'];
  if (typeof email === 'string' && email.length > 0) {
    return email;
  }
  const emails = claims['emails'];
  if (Array.isArray(emails) && typeof emails[0] === 'string' && emails[0].length > 0) {
    return emails[0];
  }
  const signInName = claims['signInName'];
  if (typeof signInName === 'string' && signInName.length > 0) {
    return signInName;
  }
  return null;
}
